import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./UnlockedSongs.module.scss";
import ribbon from "../unlocked-songs-ribbon.png";
import {FontIcon} from "../../../../common/FontIcon";

export interface IUnlockedSongsProps {
  quantityOfNewSongs: number;
  sectionId: number;
}

export const UnlockedSongs: VoidFunctionComponent<IUnlockedSongsProps> = ({quantityOfNewSongs, sectionId}) => {
  return <a href={`#/unlocked-song-lessons/${sectionId}`}>
    <aside className={s.container}>
      <div className={s.graphicTop}>
        <div className={s.oval}/>
        <div className={s.ribbon}>
          <img src={ribbon} alt="Award ribbon" width="72" height="72" />
        </div>
      </div>
      <div className={s.textBottom}>
        <div className={s.congratulations}>
          <div className={s.exclamation}>Congratulations!</div>
          <div className={s.unlocked}>Bonus songs unlocked</div>
        </div>
        <div className={s.newSongs}>
          {quantityOfNewSongs} new songs <FontIcon icon={"icon-arrow-right"}/>
        </div>
      </div>
    </aside>
  </a>;
}
